import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Hidden, Card, CardActionArea, CardMedia } from '@material-ui/core';
import { Link } from 'react-router-dom';
import emma_s1 from '../../global/imagenes/emma_s1.png';
import TareasTerminadas from './TareasTerminadas';

const rojoSuave = '#FDECEC';
const bordeRojoSuave = '#F3C7C7';
const sombraElegante = '0 8px 20px rgba(15, 23, 42, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.72)';

const useStyles = makeStyles((theme) => ({
  // Fijo (110px, se recorta si el nombre es largo): comportamiento original,
  // se mantiene para todo lo que no sea Submodulos de Semilleros.
  cardAcademico: {
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderRadius: '10px',
    background: '#FFF',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    aspectRatio: '1',
    maxHeight: '110px',
    margin: 0,
    boxSizing: 'border-box',
    boxShadow: sombraElegante,
    transition: 'all 0.2s ease',
    '&:hover': {
      background: rojoSuave,
      borderColor: bordeRojoSuave,
      boxShadow: '0 12px 24px rgba(15, 23, 42, 0.12)',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      maxHeight: '100%',
    }
  },
  // Flexible (crece con el texto, sin recorte): solo para Submodulos de
  // Semilleros (unico consumidor de MostrarSubmodulo).
  cardAcademicoSubmodulo: {
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderRadius: '10px',
    background: '#FFF',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    minHeight: '110px',
    margin: 0,
    boxSizing: 'border-box',
    boxShadow: sombraElegante,
    transition: 'all 0.2s ease',
    '&:hover': {
      background: rojoSuave,
      borderColor: bordeRojoSuave,
      boxShadow: '0 12px 24px rgba(15, 23, 42, 0.12)',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    }
  },

  cardFinanciero: {
    border: '1px solid rgba(226, 232, 240, 0.95)',
    borderRadius: '12px',
    background: '#FFF',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    height: '58px',
    minHeight: '58px',
    margin: 0,
    boxSizing: 'border-box',
    boxShadow: sombraElegante,
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      background: rojoSuave,
      borderColor: bordeRojoSuave,
      boxShadow: '0 12px 24px rgba(15, 23, 42, 0.12)',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: '10px',
      height: 'auto',
      minHeight: '58px',
    }
  },

  cardServicio: {
    border: '1px solid rgba(226, 232, 240, 0.95)',
    borderRadius: '12px',
    background: '#FFF',
    overflow: 'hidden',
    width: '100%',
    minWidth: 0,
    height: '58px',
    minHeight: '58px',
    margin: 0,
    boxSizing: 'border-box',
    boxShadow: sombraElegante,
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      background: rojoSuave,
      borderColor: bordeRojoSuave,
      boxShadow: '0 12px 24px rgba(15, 23, 42, 0.12)',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: '10px',
      height: '52px',
      minHeight: '52px',
      minWidth: 0,
    }
  },

  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    width: '100%',
    height: '100%'
  },

  imgAcademico: {
    width: 'auto',
    maxWidth: '90%',
    height: '56px',
    maxHeight: '56px',
    objectFit: 'contain',
    margin: '2px auto 1px auto',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      maxHeight: '50px',
    }
  },

  imgHorizontal: {
    width: '44px',
    height: '44px',
    objectFit: 'contain',
    margin: 0,
    display: 'block',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '42px',
      height: '42px',
    }
  },

  imgServicio: {
    width: '44px',
    height: '44px',
    objectFit: 'contain',
    margin: 0,
    display: 'block',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '32px',
      height: '32px',
    }
  },

  tituloServicio: {
    color: '#111827',
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11,
    }
  },

  tituloAcademico: {
    color: '#111827',
    fontSize: 10,
    fontWeight: 600,
    textAlign: 'center',
    padding: '0 1px 3px 1px',
    lineHeight: 1.2,
    margin: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11,
      padding: '0 1px 2px 1px',
    }
  },

  tituloHorizontal: {
    color: '#111827',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: 0,
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11,
    }
  },

  subtituloHorizontal: {
    color: '#6B7280',
    fontSize: 8,
    lineHeight: 1.1,
    marginTop: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 8,
    }
  },

  flecha: {
    color: '#9CA3AF',
    fontSize: 18,
    fontWeight: 400,
    textAlign: 'center'
  },

  cardActionArea: {
    padding: '2px 3px !important',
    [theme.breakpoints.down('sm')]: {
      padding: '2px 2px !important',
    }
  },
  cardActionAreaCompact: {
    padding: '10px 14px !important',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 10px !important',
    }
  },
  cardActionAreaServicio: {
    padding: '10px 14px !important',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 10px !important',
    }
  },
  servicioRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    flexWrap: 'nowrap',
  },
  servicioIconWrap: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 34,
    [theme.breakpoints.down('sm')]: {
      minWidth: 30,
    }
  },
  servicioTituloWrap: {
    flex: 1,
    minWidth: 0,
  }
}));

function MenuAcademicoItem({ actividad, submodulo = false }) {
  const { cardAcademico, cardAcademicoSubmodulo, cardActionArea, link, imgAcademico, tituloAcademico } = useStyles();
  const { titulo, imagen, nombre } = actividad;

  return (
    <Card className={submodulo ? cardAcademicoSubmodulo : cardAcademico}>
      <Link to={`/${nombre}`} className={link}>
        <CardActionArea className={cardActionArea} style={{ height: '100%' }}>
          <CardMedia
            component="img"
            image={imagen || actividad.icono || actividad.img}
            className={imgAcademico}
          />
          <Typography className={tituloAcademico}>
            {titulo}
          </Typography>
        </CardActionArea>
      </Link>
    </Card>
  );
}

function MenuFinancieroItem({ actividad }) {
  const {
    cardFinanciero,
    cardActionAreaCompact,
    link,
    imgHorizontal,
    tituloHorizontal,
    subtituloHorizontal
  } = useStyles();

  const { titulo, imagen, nombre } = actividad;

  return (
    <Card className={cardFinanciero}>
      <Link to={`/${nombre}`} className={link}>
        <CardActionArea className={cardActionAreaCompact} style={{ height: '100%' }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={3}>
              <CardMedia
                component="img"
                image={imagen || actividad.icono || actividad.img}
                className={imgHorizontal}
              />
            </Grid>

            <Grid item xs={9}>
              <Typography className={tituloHorizontal} align="left">
                {titulo}
              </Typography>
              {actividad.descripcion && (
                <Typography className={subtituloHorizontal} align="left">
                  {actividad.descripcion}
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardActionArea>
      </Link>
    </Card>
  );
}

function MenuServicioItem({ actividad }) {
  const {
    cardServicio,
    cardActionAreaServicio,
    link,
    imgServicio,
    tituloServicio,
    servicioRow,
    servicioIconWrap,
    servicioTituloWrap
  } = useStyles();

  const { titulo, imagen, nombre } = actividad;

  return (
    <Card className={cardServicio}>
      <Link to={`/${nombre}`} className={link}>
        <CardActionArea className={cardActionAreaServicio} style={{ height: '100%' }}>
          <div className={servicioRow}>
            <div className={servicioIconWrap}>
              <CardMedia
                component="img"
                image={imagen || actividad.icono || actividad.img}
                className={imgServicio}
              />
            </div>

            <div className={servicioTituloWrap}>
              <Typography className={tituloServicio} align="left">
                {titulo}
              </Typography>
            </div>
          </div>
        </CardActionArea>
      </Link>
    </Card>
  );
}

export default function Menu({ actividades = [], tipo = 'academico', submodulo = false }) {
  const pintarVacio = () => (
    <TareasTerminadas
      imagen={emma_s1}
      mensaje='No se encontraron datos'
      widthImg='7%'
      marginTop='3%'
    />
  );

  if (!actividades.length) return pintarVacio();

  if (tipo === 'academico') {
    const cols = actividades.length <= 4 ? 4 : 5;
    const flexVal = 100 / cols;
    return (
      <>
        <Hidden xsDown>
          <Grid
            container
            spacing={1}
            justifyContent="flex-start"
            alignItems={submodulo ? 'stretch' : 'flex-start'}
            style={{ margin: 0, width: '100%' }}
          >
            {actividades.map((actividad, key) => (
              <Grid
                item
                key={key}
                style={{ flex: `0 0 ${flexVal}%`, maxWidth: `${flexVal}%`, display: 'flex', justifyContent: 'center' }}
              >
                <MenuAcademicoItem actividad={actividad} submodulo={submodulo} />
              </Grid>
            ))}
          </Grid>
        </Hidden>

        <Hidden smUp>
          <Grid container spacing={1} alignItems={submodulo ? 'stretch' : 'flex-start'} style={{ margin: 0, width: '100%' }}>
            {actividades.map((actividad, key) => (
              <Grid item key={key} xs={6}>
                <MenuAcademicoItem actividad={actividad} submodulo={submodulo} />
              </Grid>
            ))}
          </Grid>
        </Hidden>
      </>
    );
  }

  if (tipo === 'financiero') {
    return (
      <>
        <Hidden xsDown>
          <Grid
            container
            spacing={1}
            justifyContent="flex-start"
            style={{ margin: 0, width: '100%' }}
          >
            {actividades.map((actividad, key) => (
              <Grid
                item
                key={key}
                style={{ flex: '0 0 33.3333%', maxWidth: '33.3333%', minWidth: 0 }}
              >
                <MenuFinancieroItem actividad={actividad} />
              </Grid>
            ))}
          </Grid>
        </Hidden>

        <Hidden smUp>
          <Grid container spacing={1} style={{ margin: 0, width: '100%' }}>
            {actividades.map((actividad, key) => (
              <Grid item key={key} xs={12} sm={6}>
                <MenuFinancieroItem actividad={actividad} />
              </Grid>
            ))}
          </Grid>
        </Hidden>
      </>
    );
  }

  return (
    <>
      <Hidden xsDown>
        <Grid
          container
          spacing={1}
          justifyContent="flex-start"
          style={{ margin: 0, width: '100%' }}
        >
          {actividades.map((actividad, key) => (
            <Grid
              item
              key={key}
              style={{ flex: '0 0 33.3333%', maxWidth: '33.3333%', minWidth: 0 }}
            >
              <MenuServicioItem actividad={actividad} />
            </Grid>
          ))}
        </Grid>
      </Hidden>

      <Hidden smUp>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          style={{ margin: 0, width: '100%' }}
        >
          {actividades.map((actividad, key) => (
            <Grid
              item
              key={key}
              xs={12}
              style={{ flex: '0 0 100%', minWidth: 0, maxWidth: '100%' }}
            >
              <MenuServicioItem actividad={actividad} />
            </Grid>
          ))}
        </Grid>
      </Hidden>
    </>
  );
}